import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { TrackingGroupShipment } from "@freightsimple/generated-dashboard-openapi-client/models/TrackingGroupShipment";
import { TrackingShipmentCard } from "@/Features/Tracking/CustomComponents/TrackingShipmentCard";

interface TrackingShipmentsListProps {
  shipments: TrackingGroupShipment[];
  onSelectShipment: (trackingId: string) => void;
  onHighlightShipment?: ((laneIndex: number | undefined) => void) | undefined;
}

export function TrackingShipmentsList(props: TrackingShipmentsListProps) {
  const { shipments, onSelectShipment, onHighlightShipment } = props;

  return (
    <Stack gap={8} align="stretch">
      <Stack gap={1} align="start">
        <Heading level={1} size="3xl">
          Shipment Tracking
        </Heading>
        <T size="base" color="secondary">
          Select a shipment to see its full tracking details.
        </T>
      </Stack>

      <Stack gap={4} align="center">
        {shipments.map((shipment, shipmentIndex) => (
          <TrackingShipmentCard
            key={shipment.trId}
            shipment={shipment}
            onClick={() => {
              onSelectShipment(shipment.trId);
            }}
            onMouseEnter={() => {
              onHighlightShipment?.(shipmentIndex);
            }}
            onMouseLeave={() => {
              onHighlightShipment?.(undefined);
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
